(function () {
  if (!customElements.get("biotq-media-target")) {
    class BiotqMediaTarget extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(w3elem, (event) => {
          event.preventDefault();
          const targetIndexId = this.dataset.targetIndexId;
          const parentSectionId = this.dataset.parentSectionId;
          this.showMediaElement(targetIndexId, parentSectionId);
        });
      }

      showMediaElement(targetIndexId, parentSectionId) {
        const parentElm = document.querySelector(parentSectionId);

        if (!parentElm) return;

        const currentMediaElm = parentElm.querySelector(`#video-player .biotiquest-guide__media[data-loop-index="${targetIndexId}"]`);
        console.log("currentMediaElm => ", currentMediaElm);
        if (!currentMediaElm) return;

        // Hide current Active media
        const activeMediaElm = parentElm.querySelector("#video-player .media-active");
        if (activeMediaElm) {
          activeMediaElm.classList.remove("media-active");
        }

        // Activate current media
        currentMediaElm.classList.add("media-active");

        // If not already clicked
        const playBtn = currentMediaElm.querySelector(".biotiquest-media__playbtn");
        console.log("playBtn => ", playBtn);
        if (playBtn) {
          playBtn.click();
        }
      }
    }

    customElements.define("biotq-media-target", BiotqMediaTarget);
  }
})();
